import { render, staticRenderFns } from "./Nicknames-User.vue?vue&type=template&id=1f96e669&scoped=true"
import script from "./Nicknames-User.js?vue&type=script&lang=js&external"
export * from "./Nicknames-User.js?vue&type=script&lang=js&external"
import style0 from "./Nicknames-User.vue?vue&type=style&index=0&id=1f96e669&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f96e669",
  null
  
)

export default component.exports